import { FETCH_COUNTRIES_FOR_PROJECTS } from '../constants/actionTypes'

export default (countriesForProject = [], action) => {
    switch (action.type) {
        case FETCH_COUNTRIES_FOR_PROJECTS:
            return action.payload;
        default:
            return countriesForProject;
    }
}